import classNames from "classnames";
import styles from "./index.module.scss";

const FilesCountersContainer = ({ containerStyles, children }) => {
  return (
    <div className={classNames(styles.container, containerStyles)}>
      {children}
    </div>
  );
};
export default FilesCountersContainer;
